import React, { useState, useEffect } from 'react';
import axios from 'axios';
import VerseNavigation from './VerseNavigation';
import VerseDisplay from './VerseDisplay';

const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const LineDetails = ({ line, onClose, allVerses, selectedTranslations: parentSelectedTranslations, onFilterChange: parentOnFilterChange }) => {
  const [selectedVerse, setSelectedVerse] = useState(line?.verse_number || null);
  const [currentVerses, setCurrentVerses] = useState(allVerses);

  useEffect(() => {
    if (line) {
      setSelectedVerse(line.verse_number);
      setCurrentVerses(allVerses);
    }
  }, [line, allVerses]);

  const fetchPage = async (pageNumber) => {
    try {
      const response = await axios.get(`${API_BASE}/api/lines/page/${pageNumber}`);
      if (response.data.length > 0) {
        setCurrentVerses(response.data);
        setSelectedVerse(response.data[0].verse_number);
      }
    } catch (error) {
      console.error(`Error fetching page ${pageNumber}:`, error);
    }
  };

  const handleNextVerse = async () => {
    const currentIndex = currentVerses.findIndex(v => v.verse_number === selectedVerse);
    if (currentIndex < currentVerses.length - 1) {
      setSelectedVerse(currentVerses[currentIndex + 1].verse_number);
    } else {
      await fetchPage(currentVerses[0].page_number + 1);
    }
  };

  const handlePreviousVerse = async () => {
    const currentIndex = currentVerses.findIndex(v => v.verse_number === selectedVerse);
  
    if (currentIndex > 0) {
      setSelectedVerse(currentVerses[currentIndex - 1].verse_number);
    } else {
      const prevPageNumber = currentVerses[0].page_number - 1;
  
      if (prevPageNumber > 0) {
        try {
          const response = await axios.get(`${API_BASE}/api/lines/page/${prevPageNumber}`);
  
          if (response.data.length > 0) {
            setCurrentVerses(response.data);
            setSelectedVerse(response.data[response.data.length - 1].verse_number);
          }
        } catch (error) {
          console.error(`Error fetching previous page ${prevPageNumber}:`, error);
        }
      }
    }
  };
  

  if (!line) return null;

  const currentVerse = currentVerses.find(verse => verse.verse_number === selectedVerse) || line;
  const selectedTranslations = parentSelectedTranslations || [];

  return (
    <div className="line-details" style={{ display: 'flex', flexDirection: 'column', padding: '20px', border: '1px solid #ccc', marginTop: '20px' }}>
      
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        marginBottom: '10px'
      }}>
        <button onClick={handlePreviousVerse}>Previous</button>
        <button onClick={onClose} style={{ backgroundColor: 'red', color: 'white' }}>Close</button>
        <button onClick={handleNextVerse}>Next</button>
      </div>

      <div style={{ display: 'flex' }}>
        <VerseNavigation 
          selectedVerse={selectedVerse} 
          currentVerses={currentVerses} 
          onVerseChange={setSelectedVerse} 
        />

        <VerseDisplay currentVerse={currentVerse} selectedTranslations={selectedTranslations} />
      </div>
    </div>
  );
};

export default LineDetails;
